export function scrollHint() {
  console.log("move");
  if ($(".js-scrollable").length !== 0) {
    new ScrollHint(".js-scrollable", {
      i18n: {
        scrollable: "スクロールできます。",
      },
    });
  }
}
